var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-main",class:{ 'footer-main-mobile': _vm.isMobile }},[_c('The-footer-navigation'),_c('The-filing')],1)}
var staticRenderFns = []

export { render, staticRenderFns }